import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

const LandingPage = lazy(() => import('./components/LandingPage'));
const PrivacyTermsPage = lazy(() => import('./components/PrivacyTermsPage'));
const TransparencyPage = lazy(() => import('./components/TransparencyPage'));
const EventsPage = lazy(() => import('./components/events/EventsPage'));

function RouteFallback() {
  return <div className="min-h-screen bg-theme-page" />;
}

function App() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/transparency" element={<TransparencyPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/privacy" element={<PrivacyTermsPage />} />
        <Route path="/terms" element={<PrivacyTermsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
